// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminDhl = (client) => ({
    /**
     * `POST /admin/dhl`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-dhl-v2/src/api/admin/dhl/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/dhl", { method: "POST", body, query, headers }),
    /**
     * `GET /admin/dhl`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-dhl-v2/src/api/admin/dhl/route.ts
     */
    list: (query, headers) => client.fetch("/admin/dhl", { method: "GET", query, headers }),
});
//# sourceMappingURL=dhl.js.map